/**
 * The app route's `errorElement`: hand the error to the React boundary above
 * the router.
 *
 * Under a data router the first route is always wrapped in react-router's own
 * boundary, whose default element prints the error message and stack to the
 * customer ("Unexpected Application Error!"). Rethrowing sends the error to
 * `main.tsx`'s `<AppErrorBoundary variant="inline">`, as under
 * `<BrowserRouter>`: one place for the stale-chunk reload and for Sentry.
 */

import { useRouteError } from "react-router-dom";

export function RethrowRouteError(): never {
  throw useRouteError();
}
